import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const COLUMNS = [
  { title: 'Marketplace', links: [['Hire talent', '/hire-talent'], ['Browse freelancers', '/browse-freelancers'], ['Find work', '/find-work'], ['Job postings', '/job-postings']] },
  { title: 'Academy', links: [['Courses', '/academy/courses'], ['Seminars', '/academy/seminars'], ['Project Studio', '/academy/project-studio'], ['Teams', '/teams']] },
  { title: 'Company', links: [['About us', '/about'], ['How it works', '/how-it-works'], ['Help Center', '/help']] },
  { title: 'Legal', links: [['Terms of Service', '/terms'], ['Privacy Policy', '/privacy'], ['Payments and taxes', '/payments-and-taxes']] },
];

export default function Footer() {
  const location = useLocation();
  return (
    <footer className="footer">
      {/* White, classic columns (option B of three, 2026-10-15): small and
          light so it closes the page without competing with it. */}
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo" translate="no">UniFreelancer</div>
          <p className="footer-tagline">Real work from verified students and alumni.</p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/unifreelancerinc/" target="_blank" rel="noreferrer" className="footer-social-link" aria-label="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
              </svg>
            </a>
            {/* YouTube */}
            <a href="https://www.youtube.com/@UniFreelancerMarketplace" target="_blank" rel="noreferrer" className="footer-social-link" aria-label="YouTube">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
            {/* TikTok */}
            <a href="https://www.tiktok.com/@unifreelancer.com" target="_blank" rel="noreferrer" className="footer-social-link" aria-label="TikTok">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/>
              </svg>
            </a>
            {/* LinkedIn */}
            <a href="https://www.linkedin.com/company/unifreelancer" target="_blank" rel="noreferrer" className="footer-social-link" aria-label="LinkedIn">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.446-2.136 2.94v5.666H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zM7.114 20.452H3.558V9h3.556v11.452z"/>
              </svg>
            </a>
          </div>
        </div>

        <nav className="footer-links" aria-label="Footer">
          {COLUMNS.map(({ title, links }) => (
            <div key={title} className="footer-links-col">
              <h2 className="footer-col-title">{title}</h2>
              {links.map(([label, to]) => (
                <Link key={to} to={to} className="footer-link">{label}</Link>
              ))}
              {title === 'Company' && (
                <>
                  <a href="mailto:support@unifreelancer.com?subject=Feedback" className="footer-link">Feedback</a>
                  <Link to={`/login?returnTo=${encodeURIComponent(location.pathname)}`} className="footer-link">Log in</Link>
                </>
              )}
            </div>
          ))}
        </nav>
      </div>

      <div className="footer-bottom">
        <span translate="no">© {new Date().getFullYear()} UniFreelancer</span>
        <span className="footer-accessibility">
          Aims to meet WCAG 2.1 AA. Report an issue:{' '}
          <a href="mailto:support@unifreelancer.com">support@unifreelancer.com</a>
        </span>
      </div>
    </footer>
  );
}
